import { render } from "./Timesheet.vue?vue&type=template&id=2ab2a94e&scoped=true"
import script from "./Timesheet.vue?vue&type=script&lang=js"
export * from "./Timesheet.vue?vue&type=script&lang=js"

import "./timesheet.scss?vue&type=style&index=0&id=2ab2a94e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab2a94e"]])

export default __exports__